export const CUSTOMER_IDS = {
  COVIDEO: '3',
  BENOIST_ROUSSEAU: '57756',
  COVIDEO_DEVS: '54188',
};
